import React, { useEffect, useState, useCallback } from "react";
import { Link, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import "./Navbar.css";
import Logo from "./Logo";

const NAVIGATION_LINKS = [
  { to: "/", label: "Home" },
  { to: "/what-we-do", label: "What we do" },
  { to: "/careers", label: "Careers" },
  { to: "/contact", label: "Contact" },
];

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const handleScroll = useCallback(() => {
    setIsScrolled(window.scrollY > 50);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  return (
    <>
      <Helmet>
        <style>{`
          body {
            padding-top: 70px;
          }
        `}</style>
      </Helmet>

      <header className={`navbar ${isScrolled ? "navbar-scrolled" : ""}`}>
        <div className="navbar-inner">
          {/* Logo + Company Name */}
          <Link to="/" className="navbar-brand">
            <Logo />
            <span className="navbar-company-name">DB4Cloud Technologies</span>
          </Link>

          {/* Desktop Links */}
          <nav className="navbar-links">
            {NAVIGATION_LINKS.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`navbar-link ${location.pathname === link.to ? "active" : ""}`}
              >
                {link.label}
              </Link>
            ))}
            <Link to="/contact" className="navbar-cta">
              Get Started
            </Link>
          </nav>

          {/* Mobile Toggle */}
          <button
            className="navbar-toggle"
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            <span className={`toggle-bar ${isMenuOpen ? "open" : ""}`}></span>
            <span className={`toggle-bar ${isMenuOpen ? "open" : ""}`}></span>
            <span className={`toggle-bar ${isMenuOpen ? "open" : ""}`}></span>
          </button>
        </div>

        {/* Mobile Menu Overlay */}
        <div
          className={`navbar-mobile-overlay ${isMenuOpen ? "active" : ""}`}
          onClick={toggleMenu}
        />

        {/* Mobile Menu */}
        <div className={`navbar-mobile ${isMenuOpen ? "open" : ""}`}>
          {NAVIGATION_LINKS.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`navbar-mobile-link ${location.pathname === link.to ? "active" : ""}`}
              onClick={() => setIsMenuOpen(false)}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/contact"
            className="navbar-mobile-cta"
            onClick={() => setIsMenuOpen(false)}
          >
            Get Started
          </Link>
        </div>
      </header>
    </>
  );
};

export default Navbar;
